import './Eula.css';

import { type FC, memo } from 'react';

import { PageLayout } from '@ipfabric/ui-components/PageLayout/PageLayout';
import { useLocale } from 'containers/App/LocaleContext';
import { Helmet } from 'react-helmet';
import { EulaText } from './EulaText';

const BareEula: FC = () => {
  const {
    auth: { eula: msg },
  } = useLocale();

  return (
    <PageLayout className='eula'>
      <Helmet title={msg.title} />
      <EulaText />
    </PageLayout>
  );
};

export const Eula = memo(BareEula);
